import type { NetworkAdapter, NetworkState } from '@/adapters/network/types';

const readNetworkState = (): NetworkState => {
  const isOnline = typeof navigator === 'undefined' ? false : navigator.onLine;

  return {
    type: isOnline ? 'wifi' : 'none',
    isConnected: isOnline,
    isInternetReachable: isOnline,
  };
};

const networkAdapter: NetworkAdapter = {
  getNetworkState: async () => readNetworkState(),

  addEventListener: (callback) => {
    if (typeof window === 'undefined') {
      return () => {};
    }

    const notify = () => {
      callback(readNetworkState());
    };

    window.addEventListener('online', notify);
    window.addEventListener('offline', notify);

    return () => {
      window.removeEventListener('online', notify);
      window.removeEventListener('offline', notify);
    };
  },
};

export { networkAdapter };
